<a href="#" class="list-group-item">
    <h5 title="{{name}}" class="clearfix">
        <i class="fa fa-lg fa-angle-down pull-right"></i>
        <div class="slidedown-menu-active-text">
            <span class="text-muted">#{{id}}</span> {{name}}
        </div>
    </h5>
</a>
